import {
  INotificationTemplate,
  INotificationFromTemplateSaveRequest,
  INotificationReportInfo,
  ITemplateOption,
} from '../business-objects/common';
import GetNotificationTemplateInfoResponse from '../business-objects/GetNotificationTemplateInfoResponse';
import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';
import * as actionTypes from './actionTypes';
import * as urls from '../../shared/urls';

export const getAllTokens = (url: string) => {
  return async (dispatch) => {
    try {
      await Api.get(url).then((res: ApiResponse<any>) => {
        if (res.ok) {
          dispatch(saveTokenInfoToStore(res.data));
        }
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const saveTokenInfoToStore = (TokenInfo: any) => {
  return {
    type: actionTypes.SAVE_TOKEN_INFO_TO_STORE,
    value: TokenInfo,
  };
};

export const getAllTemplates = (url: string) => {
  return async (dispatch, stateInfo) => {
    try {
      if (!stateInfo().NotificationTemplates.storeUpdated)
        await Api.get(url).then((res: ApiResponse<any>) => {
          if (res.ok) {
            dispatch(saveNotificationInfoToStore(res.data));
          }
        });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const getTemplateOptionsById = (url: string, optionId: number) => {
  return async (dispatch) => {
    try {
      await Api.get(url + '?optionId=' + optionId).then(
        (result: ApiResponse<any>) => {
          dispatch(loadTemplateOptionsIntoStore(result.data));
          return Promise.resolve(result.data);
        }
      );
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const getNotificationReportInfo = (url: string, reportId: number) => {
  return async (dispatch) => {
    try {
      await Api.get(url + '?reportId=' + reportId).then(
        (result: ApiResponse<any>) => {
          dispatch(reduceNotifcationReportInfo(result.data));
          return Promise.resolve(result.data);
        }
      );
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const reduceNotifcationReportInfo = (data: INotificationReportInfo) => {
  return {
    type: actionTypes.GET_NOTIFICATION_REPORT_INFO,
    value: data,
  };
};

export const getTemplateOptions = (url: string) => {
  return async (dispatch) => {
    try {
      await Api.get(url).then((result: ApiResponse<any>) => {
        dispatch(loadTemplateOptionsIntoStore(result.data));
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const getTemplatesByOption = (optionId?: number) => {
  return async (dispatch) => {
    try {
      await Api.get(
        `${urls.GET_TEMPLATES_BY_OPTION}?optionId=${optionId}`
      ).then((result: ApiResponse<any>) => {
        dispatch(loadNotificationTemplatesIntoStore(result.data));
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const loadNotificationTemplatesIntoStore = (
  notificationTemplates: INotificationTemplate[]
) => {
  return {
    type: actionTypes.LOAD_TEMPLATES_BY_OPTION,
    value: notificationTemplates,
  };
};

export const saveNotificationInfoToStore = (
  notificationInfo: GetNotificationTemplateInfoResponse
) => {
  return {
    type: actionTypes.SAVE_NOTIFICATION_INFO_TO_STORE,
    value: notificationInfo,
  };
};

export const saveNewNotifications = (
  url: string,
  notification: INotificationTemplate
) => {
  return async (dispatch) => {
    try {
      await Api.post(url, notification).then((res: ApiResponse<any>) => {
        dispatch(saveNewNotificationToStore(res.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const saveNotificationByTemplate = (
  url: string,
  request: INotificationFromTemplateSaveRequest
) => {
  return async (dispatch) => {
    try {
      await Api.post(url, request).then((res: ApiResponse<any>) => {
        dispatch(saveNewNotificationToStore(res.data));
        return Promise.resolve(res.data);
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const saveUpdatedNotificationTemplate = (
  url: string,
  notification: INotificationTemplate
) => {
  return async (dispatch) => {
    try {
      await Api.put(url, notification).then((res: ApiResponse<any>) => {
        dispatch(saveUpdatedNotificationTemplateToStore(res.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const loadTemplateOptionsIntoStore = (
  templateOptions: ITemplateOption[]
) => {
  return {
    type: actionTypes.LOAD_TEMPLATE_OPTIONS_INTO_STORE,
    value: templateOptions,
  };
};

export const loadTemplateOptionsIntoStoreById = (
  templateOptions: ITemplateOption[]
) => {
  return {
    type: actionTypes.LOAD_TEMPLATE_OPTIONS_INTO_STORE_BY_ID,
    value: templateOptions,
  };
};

export const saveUpdatedNotificationTemplateToStore = (
  notification: INotificationTemplate
) => {
  return {
    type: actionTypes.UPDATE_NOTIFICATION_TEMPLATE,
    value: notification,
  };
};

export const saveNewNotificationToStore = (
  notification: INotificationTemplate
) => {
  return {
    type: actionTypes.CREATE_NOTIFICATION_TEMPLATE,
    value: notification,
  };
};

export const toggleLoading = () => {
  return {
    type: actionTypes.TOGGLE_IS_PROCESSING,
  };
};
